import apiClient, { toApiError } from "@/services/api/client";
import { ApiResponse } from "@/types/api.types";
import { NotificationPreferences } from "@/types/notification.types";

export const preferencesApi = {
  // Get notification preferences
  getNotificationPreferences: async (): Promise<NotificationPreferences> => {
    try {
      const response = await apiClient.get<
        ApiResponse<{ preferences: NotificationPreferences }>
      >("/notifications/preferences");
      return response.data.data.preferences;
    } catch (error) {
      throw toApiError(error);
    }
  },

  // Update notification preferences
  updateNotificationPreferences: async (
    preferences: Partial<NotificationPreferences>,
  ): Promise<NotificationPreferences> => {
    try {
      const response = await apiClient.put<
        ApiResponse<{ preferences: NotificationPreferences }>
      >("/notifications/preferences", preferences);
      return response.data.data.preferences;
    } catch (error) {
      throw toApiError(error);
    }
  },

  // Verify phone for SMS alerts
  verifyPhone: async (phoneNumber: string): Promise<void> => {
    try {
      await apiClient.post("/notifications/verify-phone", { phoneNumber });
    } catch (error) {
      throw toApiError(error);
    }
  },
};
